// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (c) 2022 Imixs Software Solutions GmbH,
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 3
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU
 * General Public License for more details.
 *
 * You can receive a copy of the GNU General Public
 * License at http://www.gnu.org/licenses/gpl.html
 *
 * Project:
 *     https://github.com/imixs/open-bpmn
 *
 * Contributors:
 *     Imixs Software Solutions GmbH - Project Management
 *     Ralph Soika - Software Developer
 ********************************************************************************/
:root {
    --jsonforms-label-width: 250px;
    --jsonforms-line-height: 28px;
    --jsonforms-margin: 4px;
    --jsonforms-padding: 8px;
}

.vertical-layout {
	display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: var(--jsonforms-padding);
}
.horizontal-layout {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: var(--jsonforms-padding);
}


.vertical-layout>* {
    display: table-row;
    width: 100%;
}
.horizontal-layout>* {
  flex: 1;
}


.vertical-layout-item .control {
    display: flex;
    flex-direction: column;
	margin: var(--jsonforms-margin);
    padding-right: var(--jsonforms-padding)
}
.horizontal-layout-item .control {
	display: flex;
    flex-direction: column;
    margin: var(--jsonforms-margin);
    padding-right: var(--jsonforms-padding)
}


.vertical-layout-item>label {
    flex: none;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    align-items: center;
}


.horizontal-layout[hidden] {
  display: none;
}



.array-table-layout table {
    border-spacing: 0;
    width: 100%;
}

.control>label, .array-table-layout.control>header>label {
    flex: none;
    display: flex;
    width: var(--jsonforms-label-width);
    height: var(--jsonforms-line-height);
    align-items: center;
}

.control>input, .control>select, .array-table-layout td input, .array-table-layout td select {
    display: flex;
    height: var(--jsonforms-line-height);
    width: 100%;
    padding: 0 5px;
    background: var(--theia-input-background) !important;
    flex-basis: auto;
    flex-shrink: 1 !important;
    flex-grow: 0 !important;
    color: var(--theia-input-foreground);
    border: 1px solid var(--theia-dropdown-border); 
}
.control>textarea {
    display: flex;
    height: var(--jsonforms-line-height);
    width: 100%;
    padding: 0 5px;
    background: var(--theia-input-background) !important;
    flex-basis: auto;
    flex-shrink: 1 !important;
    flex-grow: 0 !important;
    color: var(--theia-input-foreground);
    border: 1px solid var(--theia-dropdown-border);
    resize: vertical;
    min-height: 7em;
}

.control>input[type="date"]::-webkit-calendar-picker-indicator {
    /* filter to invert calendar icon of date input field is visible in both themes */
    filter: invert(0.5);
}

.control>select {
    padding: 0 !important;
}

.control>input[type="checkbox"] {
    display: flex !important;
    flex: none !important;
    outline: none !important;
    margin: 0;
}

.control>input[disabled], .array-table-layout td input[disabled], .array-table-layout td select[disabled] {
    opacity: 0.5;
}

.control>.validation {
    font-size: var(--theia-ui-font-size1);
    text-align: left;
    font-family: var(--theia-ui-font-family);
    padding-left: 3px;
    order: 2;
}

.control>.validation_error, .control>.validate.invalid {
    color: var(--theia-editorError-foreground);
}

.array-table-layout.control>header {
    margin-top: 10px;
    display: flex;
    width: var(--jsonforms-label-width);
    flex: none;
    flex-direction: column;
}

.array-table-layout.control>header>button {
    margin: 10px 10px 0 0;
    align-self: flex-start;
}

.array-table-layout.control>table>thead {
}

.array-table-layout.control>table>tbody>tr>td>input {
    width: 100%;
}

.array-table-layout.control>table>tbody>tr>td>span {
    /* .validation error */
    font-size: var(--theia-ui-font-size1);
    text-align: left;
    font-family: var(--theia-ui-font-family);
    padding-left: 3px;
    order: 2;
    color: var(--theia-editorError-foreground);
    margin-left: 12px;
}

.array-table-layout.control>table>tbody>tr>td>button {
    /* theia-button */
    border: none;
    color: var(--theia-button-foreground);
    background-color: var(--theia-button-background);
    min-width: 65px;
    outline: none;
    cursor: pointer;
    padding: 4px 9px;
    margin-left: calc(var(--theia-ui-padding)*2);
    border-radius: 1px;
    box-shadow: 0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 1px 2px 0px rgb(0 0 0 / 14%), 0px 1px 1px -2px rgb(0 0 0 / 12%);
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.array-table-layout.control>table>tbody>tr>td:last-child {
    width: 1%;
}

.array-table-layout.control>table>tbody>tr>td>button:focus {
    background-color: var(--theia-button-hoverBackground);
}


/* Layouts */


.group-layout {
  display: flex;
  flex-direction: column;
  border-style: solid;
  border-color: var(--jsf-border-color);
  border-width: thin;
  border-radius: 0.2em;
}

.group-layout[hidden] {
  display: none;
}

.group-layout>legend {
  padding: 0 0.5em;
  font-weight: bold;
  color: var(--jsf-main-fg-color);
}

.categorization {
  display: flex;
  flex-direction: row;
}

.categorization[hidden] {
  display: none;
}

.categorization>* {
}

.categorization>*:first-child {
  margin-right: 0.25em;
}

.categorization>.categorization-master {
  flex: 1;
  background: var(--theia-menu-background);
}

.categorization>.categorization-master ul {
  list-style-type: none;
  font-weight: normal;
  padding: 0;
}

.categorization>.categorization-master ul>li>span {
  cursor: pointer;
  display: block;
  color: var(--jsf-main-fg-color);
  padding: var(--jsonforms-padding);
}

.categorization>.categorization-master ul>li>span:hover {
  background: var(--theia-list-hoverBackground);
}

.categorization>.categorization-master ul>li.category-group>ul {
  padding-left: 0.5em;
}

.categorization>.categorization-master ul>li.category-group>span {
  cursor: default;
}

.categorization>.categorization-master ul>li.category-group>span:hover {
  font-weight: normal;
}

.categorization>.categorization-master ul>li.selected>span {
  font-weight: bold;
  border-top: 1px solid var(--theia-focusBorder);
  border-bottom: 1px solid var(--theia-focusBorder);
  background: var(--theia-sideBar-background);
}

.categorization>.categorization-detail {
  flex: 6;
}
`, "",{"version":3,"sources":["webpack://./../open-bpmn-properties/css/jsonforms-theia.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;iFAsBiF;AACjF;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;CACC,aAAa;IACV,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;;AAGA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;EACE,OAAO;AACT;;;AAGA;IACI,aAAa;IACb,sBAAsB;CACzB,+BAA+B;IAC5B;AACJ;AACA;CACC,aAAa;IACV,sBAAsB;IACtB,+BAA+B;IAC/B;AACJ;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;;AAGA;EACE,aAAa;AACf;;;;AAIA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mCAAmC;IACnC,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,WAAW;IACX,cAAc;IACd,oDAAoD;IACpD,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,oCAAoC;IACpC,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,oCAAoC;IACpC,WAAW;IACX,cAAc;IACd,oDAAoD;IACpD,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,oCAAoC;IACpC,8CAA8C;IAC9C,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iFAAiF;IACjF,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,wCAAwC;IACxC,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mCAAmC;IACnC,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;AACA;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,qCAAqC;IACrC,gBAAgB;IAChB,wCAAwC;IACxC,iBAAiB;IACjB,QAAQ;IACR,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,qCAAqC;IACrC,gDAAgD;IAChD,eAAe;IACf,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,4CAA4C;IAC5C,kBAAkB;IAClB,iHAAiH;IACjH,sHAAsH;AAC1H;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qDAAqD;AACzD;;;AAGA,YAAY;;;AAGZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;AACA;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,iDAAiD;EACjD,2CAA2C;AAC7C;;AAEA;EACE,OAAO;AACT","sourcesContent":["/********************************************************************************\n * Copyright (c) 2022 Imixs Software Solutions GmbH,\n *\n * This program is free software; you can redistribute it and/or\n * modify it under the terms of the GNU General Public License\n * as published by the Free Software Foundation; either version 3\n * of the License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU\n * General Public License for more details.\n *\n * You can receive a copy of the GNU General Public\n * License at http://www.gnu.org/licenses/gpl.html\n *\n * Project:\n *     https://github.com/imixs/open-bpmn\n *\n * Contributors:\n *     Imixs Software Solutions GmbH - Project Management\n *     Ralph Soika - Software Developer\n ********************************************************************************/\n:root {\n    --jsonforms-label-width: 250px;\n    --jsonforms-line-height: 28px;\n    --jsonforms-margin: 4px;\n    --jsonforms-padding: 8px;\n}\n\n.vertical-layout {\n\tdisplay: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: var(--jsonforms-padding);\n}\n.horizontal-layout {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: var(--jsonforms-padding);\n}\n\n\n.vertical-layout>* {\n    display: table-row;\n    width: 100%;\n}\n.horizontal-layout>* {\n  flex: 1;\n}\n\n\n.vertical-layout-item .control {\n    display: flex;\n    flex-direction: column;\n\tmargin: var(--jsonforms-margin);\n    padding-right: var(--jsonforms-padding)\n}\n.horizontal-layout-item .control {\n\tdisplay: flex;\n    flex-direction: column;\n    margin: var(--jsonforms-margin);\n    padding-right: var(--jsonforms-padding)\n}\n\n\n.vertical-layout-item>label {\n    flex: none;\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n    align-items: center;\n}\n\n\n.horizontal-layout[hidden] {\n  display: none;\n}\n\n\n\n.array-table-layout table {\n    border-spacing: 0;\n    width: 100%;\n}\n\n.control>label, .array-table-layout.control>header>label {\n    flex: none;\n    display: flex;\n    width: var(--jsonforms-label-width);\n    height: var(--jsonforms-line-height);\n    align-items: center;\n}\n\n.control>input, .control>select, .array-table-layout td input, .array-table-layout td select {\n    display: flex;\n    height: var(--jsonforms-line-height);\n    width: 100%;\n    padding: 0 5px;\n    background: var(--theia-input-background) !important;\n    flex-basis: auto;\n    flex-shrink: 1 !important;\n    flex-grow: 0 !important;\n    color: var(--theia-input-foreground);\n    border: 1px solid var(--theia-dropdown-border); \n}\n.control>textarea {\n    display: flex;\n    height: var(--jsonforms-line-height);\n    width: 100%;\n    padding: 0 5px;\n    background: var(--theia-input-background) !important;\n    flex-basis: auto;\n    flex-shrink: 1 !important;\n    flex-grow: 0 !important;\n    color: var(--theia-input-foreground);\n    border: 1px solid var(--theia-dropdown-border);\n    resize: vertical;\n    min-height: 7em;\n}\n\n.control>input[type=\"date\"]::-webkit-calendar-picker-indicator {\n    /* filter to invert calendar icon of date input field is visible in both themes */\n    filter: invert(0.5);\n}\n\n.control>select {\n    padding: 0 !important;\n}\n\n.control>input[type=\"checkbox\"] {\n    display: flex !important;\n    flex: none !important;\n    outline: none !important;\n    margin: 0;\n}\n\n.control>input[disabled], .array-table-layout td input[disabled], .array-table-layout td select[disabled] {\n    opacity: 0.5;\n}\n\n.control>.validation {\n    font-size: var(--theia-ui-font-size1);\n    text-align: left;\n    font-family: var(--theia-ui-font-family);\n    padding-left: 3px;\n    order: 2;\n}\n\n.control>.validation_error, .control>.validate.invalid {\n    color: var(--theia-editorError-foreground);\n}\n\n.array-table-layout.control>header {\n    margin-top: 10px;\n    display: flex;\n    width: var(--jsonforms-label-width);\n    flex: none;\n    flex-direction: column;\n}\n\n.array-table-layout.control>header>button {\n    margin: 10px 10px 0 0;\n    align-self: flex-start;\n}\n\n.array-table-layout.control>table>thead {\n}\n\n.array-table-layout.control>table>tbody>tr>td>input {\n    width: 100%;\n}\n\n.array-table-layout.control>table>tbody>tr>td>span {\n    /* .validation error */\n    font-size: var(--theia-ui-font-size1);\n    text-align: left;\n    font-family: var(--theia-ui-font-family);\n    padding-left: 3px;\n    order: 2;\n    color: var(--theia-editorError-foreground);\n    margin-left: 12px;\n}\n\n.array-table-layout.control>table>tbody>tr>td>button {\n    /* theia-button */\n    border: none;\n    color: var(--theia-button-foreground);\n    background-color: var(--theia-button-background);\n    min-width: 65px;\n    outline: none;\n    cursor: pointer;\n    padding: 4px 9px;\n    margin-left: calc(var(--theia-ui-padding)*2);\n    border-radius: 1px;\n    box-shadow: 0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 1px 2px 0px rgb(0 0 0 / 14%), 0px 1px 1px -2px rgb(0 0 0 / 12%);\n    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.array-table-layout.control>table>tbody>tr>td:last-child {\n    width: 1%;\n}\n\n.array-table-layout.control>table>tbody>tr>td>button:focus {\n    background-color: var(--theia-button-hoverBackground);\n}\n\n\n/* Layouts */\n\n\n.group-layout {\n  display: flex;\n  flex-direction: column;\n  border-style: solid;\n  border-color: var(--jsf-border-color);\n  border-width: thin;\n  border-radius: 0.2em;\n}\n\n.group-layout[hidden] {\n  display: none;\n}\n\n.group-layout>legend {\n  padding: 0 0.5em;\n  font-weight: bold;\n  color: var(--jsf-main-fg-color);\n}\n\n.categorization {\n  display: flex;\n  flex-direction: row;\n}\n\n.categorization[hidden] {\n  display: none;\n}\n\n.categorization>* {\n}\n\n.categorization>*:first-child {\n  margin-right: 0.25em;\n}\n\n.categorization>.categorization-master {\n  flex: 1;\n  background: var(--theia-menu-background);\n}\n\n.categorization>.categorization-master ul {\n  list-style-type: none;\n  font-weight: normal;\n  padding: 0;\n}\n\n.categorization>.categorization-master ul>li>span {\n  cursor: pointer;\n  display: block;\n  color: var(--jsf-main-fg-color);\n  padding: var(--jsonforms-padding);\n}\n\n.categorization>.categorization-master ul>li>span:hover {\n  background: var(--theia-list-hoverBackground);\n}\n\n.categorization>.categorization-master ul>li.category-group>ul {\n  padding-left: 0.5em;\n}\n\n.categorization>.categorization-master ul>li.category-group>span {\n  cursor: default;\n}\n\n.categorization>.categorization-master ul>li.category-group>span:hover {\n  font-weight: normal;\n}\n\n.categorization>.categorization-master ul>li.selected>span {\n  font-weight: bold;\n  border-top: 1px solid var(--theia-focusBorder);\n  border-bottom: 1px solid var(--theia-focusBorder);\n  background: var(--theia-sideBar-background);\n}\n\n.categorization>.categorization-detail {\n  flex: 6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
